export default "__VITE_ASSET__ByyJM_N2__"